import { GroupType } from "./GroupType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity Users


export interface User {
    id: ID;

    
    email: string;

    
    hashPassword: string;

    
    activated: boolean;

    
    banned: boolean;

    
    createdAt: Date;

    
    updatedAt: Date;

    
    userGroupId: ID;

    }

export interface FilterUserEmailRequest {
    list: ListRequest,
    filter: {
        
            email?: string,
        
    
    



        userGroupIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateUser {
    
    email: string;

    
    hashPassword: string;

    
    activated: boolean;

    
    banned: boolean;

    
    
    
    }


export interface UpdateUser {
    
    
    hashPassword: string;

    
    activated: boolean;

    
    banned: boolean;

    
    
    
    }

export interface PresentationUserRequest {
    list: ListRequest,
    filter: {
        email: string,
        emailOr: boolean,
        userGroupIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryUser {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: User): PrimaryUser | undefined {
        return entity ? new PrimaryUser(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryUser {
        return new PrimaryUser(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryUser {
        let vals = path?.split('/');
        return new PrimaryUser(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryUser[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: User): string {
    let fields = entity ? [
    entity.email,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityUser {
    id: PrimaryUser;
    data: UpdateUser;


    constructor(id: PrimaryUser, data: UpdateUser) {
        this.id = id;
        this.data = data;
    }
}
